import React from "react";
import { useRouteError } from "react-router-dom";

export function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div id="error-page">
            <h1>Es ist ein Fehler aufgetreten!</h1>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
        </div>
    );
}
